import React, {useState, useContext, useEffect} from "react"
import _ from "lodash"

import Data from "../data/"

import {CatalogueContext} from "./CatalogueContext"

// context
const SearchContext = React.createContext()

// helper
function getDefaultFilter() {
  return {
    regions:{items:[], allSelected:false},
    genders:{items:[], allSelected:false},
    categories:{items:[], allSelected:false},
    tags:{items:[], title:null}, // tags we get via query string, e.g. ?tags=winter,action
    kinds:{items:[], allSelected:false}, 
    text:'',
    priceRange: {
      min:0,
      max:999999
    }
  }
}

// provider component
function SearchProvider(props) {
  // contexts
  const CC = useContext(CatalogueContext)

  // state management
  const [resetTimestamp, setResetTimestamp] = useState(Date.now()) // we use this so our FilterToggle component can reset its state
  const [searchResult, setSearchResult] = useState([]); 
  const [searchResultPackages, setSearchResultPackages] = useState([]); 
  const [searchToggles, setSearchToggles] = useState({genders:[], categories:[], regions:[], kinds:[]})
  const [searchFilter, setSearchFilter] = useState(getDefaultFilter());
  const [tagsTitle, setTagsTitle] = useState(null);
  const [subcatalogue, setSubcatalogue] = useState("singles"); // "singles" or "packages"

  // mount
  useEffect(() => {
    // search
    if(CC.isReady) {
      setSearchResult(Data.Catalogue.getFiltered());
      setSearchResultPackages(Data.ActivityPackages.getFiltered());
      setSearchToggles(createToggles());
    }
  }, [CC.isReady])

  // provider value
  const value = {
    // data
    resetTimestamp:resetTimestamp,
    result:searchResult,
    resultPackages: searchResultPackages,
    filter:searchFilter,
    toggles:searchToggles,
    tagsTitle:tagsTitle,
    subcatalogue:subcatalogue,
    //homeDeliveryItems,

    // functions
    setSubcatalogue: (subcatalogue) => {
      setSubcatalogue(subcatalogue);
      // reset filters
      let filter= getDefaultFilter()
      Data.Catalogue.filter(filter)
      setTagsTitle(null);
      setSearchFilter(filter);
      setResetTimestamp(Date.now());
      setSearchResult(Data.Catalogue.getFiltered());
      setSearchResultPackages(Data.ActivityPackages.getFiltered());
    },
    filterByKey: (key, value) => {
      let filter = {...searchFilter, tags:{items:[], title:null}} // remove the query tags filter
      filter[key] = value;
      
      setTagsTitle(null);
      setSearchFilter(filter);
      if(subcatalogue === "singles") {
        Data.Catalogue.filter(filter);
        setSearchResult(Data.Catalogue.getFiltered());
      }
      else {
        Data.ActivityPackages.filter(filter);
        setSearchResultPackages(Data.ActivityPackages.getFiltered());
      }
      
    },
    filterByTags: (tags, title) => {
      // note: any other filtering action will delete the query tags filter
      let filter = {...searchFilter};
      filter["tags"] = {items:tags, title:title};
      setTagsTitle(title);
      setSearchFilter(filter);
      if(subcatalogue === "singles") {
        Data.Catalogue.filter(filter);
        setSearchResult(Data.Catalogue.getFiltered());
      }
      else {
        Data.ActivityPackages.filter(filter);
        setSearchResultPackages(Data.ActivityPackages.getFiltered());
      }
      
    },
    toggle: (group, item, active) => {
      let filter = {...searchFilter, tags:{items:[], title:null}} // remove the query tags filter
      // add/remove from filter
      _.remove(filter[group].items, v => v === item)
      if(active) {
        filter[group].items.push(item)
      }
      // set the allSelected flag
      filter[group].allSelected = filter[group].items.length === searchToggles[group].length
      //
      setTagsTitle(null);
      setSearchFilter(filter); 
      // apply the filter
      if(subcatalogue === "singles") {
        Data.Catalogue.filter(filter);
        setSearchResult(Data.Catalogue.getFiltered());
      }
      else {
        Data.ActivityPackages.filter(filter);
        setSearchResultPackages(Data.ActivityPackages.getFiltered());
      }
    },
    sort:(sortBy) => {
      if(subcatalogue === "singles") {
        Data.Catalogue.sort(sortBy);
        setSearchResult(Data.Catalogue.getFiltered());
      }
      else {
        Data.ActivityPackages.sort(sortBy);
        setSearchResultPackages(Data.ActivityPackages.getFiltered());
      }
    },
    reset:() => {
      let filter= getDefaultFilter();
      Data.Catalogue.filter(filter);
      Data.ActivityPackages.filter(filter);
      setTagsTitle(null);
      setSearchFilter(filter);
      setResetTimestamp(Date.now());
      setSearchResult(Data.Catalogue.getFiltered());
      setSearchResultPackages(Data.ActivityPackages.getFiltered());
    }
  }

  // render
  return (
    <SearchContext.Provider value={value}>
      {props.children}
    </SearchContext.Provider>
  )
}

function createToggles() {
  const regionToggles = Data.Regions.get().map(region => {
    return {code: region.code, label: region.title.de}
  })
  const toggles = {
    regions: regionToggles,
    genders: [
      { key:'women', tag: 'frauen', label: 'Frauen' },
      { key:'couples', tag: 'paare', label: 'Paare' },
      { key:'men', tag: 'männer', label: 'Männer' }
    ],
    categories: [
      { tag: 'kulinarisches', label: 'Kulinarik' },
      { tag: 'fun', label: 'Fun' },
      { tag: 'wellness', label: 'Wellness' },
    ],
    kinds: [
      //{ value:'standard', label:"Aktivitäten"},
      //{ value:'packages', label:"Kombinationen"}
      //{ value:'homedelivery', label:"zuhause"},
      //{ value:'onlineevent', label:"online"},
    ]
  }

  return toggles;
}

export {SearchContext, SearchProvider}